(function () {

    var formApp = angular.module('formApp')
        .filter('fileSize', function () {
        return function (input) {
            const k = 1024;
            const roundTo = 2;
            input = input || '';
            return parseFloat((input / Math.pow(k, 2)).toFixed(roundTo));
        };
    })
    //set the controller to the code here - the controller uses DataServices.
    formApp.controller('documentController', ['$scope', '$window', '$http', 'DataServices', 'UtilityServices', 'ValidationService', 'FileUploader', '$log', '$location', '$routeParams', '$filter', '$anchorScroll', '$timeout', '$rootScope', 'Constants', 'fileSizeFilter', function ($scope, $window, $http, DataServices, UtilityServices, ValidationService, FileUploader, $log, $location, $routeParams, $filter, $anchorScroll, $timeout, $rootScope, Constants, fileSizeFilter) {
        const max_file_limit = 20;
        const max_file_size = 26214400;
        const max_file_total_size = 157286400;

        $scope.currentPageIndex = 0;
        $scope.currentUploadingFile = null;
        $scope.currentFileAttached = "";
        $scope.attachment = {};
        $scope.isViewing = [];
        $scope.isRemoving = [];

        //Utility Services
        $scope.utility = UtilityServices;

        $scope.isDH = function () {
            if ($location.path().indexOf('DH') > -1) {
                $scope.IsDHVisible = true;
                return true;
            }
            else {
                $scope.IsDHVisible = false;
                return false;
            }
        }

        //create the file upload for each attachment
        function createFileUploaderForAttachment() {

            if (DataServices.isAuthenticated()) {
                var fileUploader = $scope.uploader = new FileUploader({ headers: { 'Authorization': 'Bearer ' + $window.sessionStorage.getItem('adal.access.token.key' + $window.__env.AzureADSettings.endpoints[$window.__env.apiUrl]) }, withCredentials: true });
            } else {
                var fileUploader = $scope.uploader = new FileUploader({});
            }

            if (!$scope.responses.documents) {
                $scope.responses.documents = [];
            }
            if ($scope.responses.documents && $scope.responses.documents.length > 0) {
                console.log('Documents', $scope.responses.documents);
                _($scope.responses.documents).forEach(function (docsAlreadyUploaded) {
                    if (docsAlreadyUploaded.documentId) {
                        var objectToInsert = {
                            file: {
                                name: docsAlreadyUploaded.name,
                                size: docsAlreadyUploaded.size,
                                type: docsAlreadyUploaded.type,
                                isFocus: docsAlreadyUploaded.isFocus
                            },
                            documentId: docsAlreadyUploaded.documentId,
                            uploadDateTime: docsAlreadyUploaded.uploadDateTime,
                            isUploaded: true,
                            isReady: false,
                            isDeletedDisabled: docsAlreadyUploaded.isDeleteDisabled
                        };
                        fileUploader.queue.push(objectToInsert);
                    }
                });
            }

            //this method gets executed before the upload begins
            fileUploader.onBeforeUploadItem = function (fileItem) {
                fileItem.isFocus = false;
                $scope.currentProgressMessage = "Uploading " + fileItem.file.name + " file";
            }
            fileUploader.filters.push({
                name: 'customFilter',
                fn: function (item /*{File|FileLikeObject}*/, options) {
                    //donot allow more then 10 files for one attachment
                    if (this.queue.length >= max_file_limit) {
                        $scope.utility.openPopup('totalFileNumberperAttachment');
                        document.getElementById('file-input').value = ""
                    }
                    return this.queue.length < max_file_limit;
                }
            });

            //method executes after the file is chosen in file uploader
            fileUploader.onAfterAddingFile = function (fileItem) {
                document.getElementById('file-input').value = ""
                if (fileItem.file) {
                    if (isValidExtensions(fileItem.file.type, fileItem.file.name)) {
                        if (parseInt(fileItem.file.size) > max_file_size) {
                            $scope.utility.openPopup('fileItemSizeLimit');
                            fileItem.cancel();
                            fileItem.remove();
                            return;
                        }
                        validateAndUpload(fileItem);
                    }
                    else {
                        fileItem.cancel();
                        fileItem.remove();
                        $scope.utility.openPopup('invalidDocumentType');
                    }
                }
            };


            //method executes after file upload succeeds or fails
            fileUploader.onCompleteItem = function (fileItem, response, status, headers) {
                $scope.currentProgressMessage = "Uploaded " + fileItem.file.name + " file";
                fileItem.isFocus = true;
            };

            //method exceutes after file upload starts
            fileUploader.onProgressItem = function (fileItem, progress) {
                if (fileItem) {
                    $scope.currentUploadingFile = fileItem;
                }
            };

            //method executes when file upload succeeds
            fileUploader.onSuccessItem = function (fileItem, response, status, headers) {
                document.getElementById('file-input').value = ""
                if (response.documentId && response.documentOperationStatus == 3) {
                    fileItem.documentId = response.documentId;

                    _($scope.responses.documents).forEach(function (value) {
                        //check for file name aswell
                        if (!value.documentId && fileItem.file.name == value.name) {
                            value.documentId = response.documentId;
                            value.isDocUploaded = true;
                            value.isDeletedDisabled = false;
                        }
                    });
                    DataServices.responseInfo.responses.documents = $scope.responses.documents;
                    DataServices.responseInfo.incidentId = response.parentId;
                    DataServices.trackEventsWithGA('Upload Document ' + $scope.pageUrl, 'Click Upload', 'Successful upload document.');
                }
                else if (response.documentOperationStatus == 2) {
                    fileItem.isUploaded = false;
                    fileItem.remove();
                    onErrorSave('errorConcurrencyUploadDoc', 'Upload attachment');
                }
                else if (!response.documentId) {
                    fileItem.isUploaded = false;
                    fileItem.remove();
                    onErrorSave('errorUploadDoc', 'Upload attachment');
                }
                else {
                    fileItem.isUploaded = false;
                    fileItem.remove();
                    onErrorSave('errorUploadDoc', 'Upload attachment');
                }
            };

            fileUploader.onErrorItem = function (fileItem, response, status, headers) {
                document.getElementById('file-input').value = ""
                fileItem.isUploaded = false;
                fileItem.remove();
                onErrorSave('errorUploadDoc', 'Upload attachment');
            };
            return fileUploader;
        }

        $scope.initPageAttachments = function () {
            //create file uploaders for the attachments          
            $scope.attachment.fileUploader = createFileUploaderForAttachment();
        }

        //deletes attachments for the users after confirmation
        $scope.removeFileItem = function (fileItem) {
            if (fileItem.documentId) {
                var params = fileItem.file;
                $scope.utility.openPopup('confirmDeleteFile', params).result.then(
                    function (result) {
                        if (!fileItem.documentId) {
                            fileItem.remove();
                        }
                        else {
                            $scope.isRemoving[fileItem.documentId] = true;
                            DataServices.deleteDocument(fileItem.documentId)
                                .then(function (response) {
                                    var data = response && response.data;
                                    if (data && data.documentOperationStatus == "3") {

                                        //below remove deletes the item from the queue, cannot use  fileItem.remove();as fileitem would not be available
                                        _.remove($scope.attachment.fileUploader.queue, function (queueItem) {
                                            return queueItem.documentId === fileItem.documentId;
                                        });

                                        _.remove($scope.responses.documents, function (item) {
                                            return item.documentId === fileItem.documentId;
                                        });

                                        $scope.responses.documents = _.uniqWith($scope.responses.documents, _.isEqual);
                                        DataServices.responseInfo.responses.documents = $scope.responses.documents;
                                        DataServices.responseInfo.lastUpdatedTime = data.lastUpdatedTime;

                                        DataServices.trackEventsWithGA('Delete Document ' + $scope.pageUrl, 'Click Remove attachment', 'Successful delete document.');
                                    }
                                    else if (data && data.documentOperationStatus == "2") {
                                        fileItem.isDeletedDisabled = false;
                                        $scope.utility.openPopup('errorConcurrencyUploadDoc', { lastUpdatedBy: data.LastUpdatedBy });
                                    }
                                    else {
                                        fileItem.isDeletedDisabled = false;
                                        onErrorSave('errorDeleteDoc', 'Delete Attachment');
                                    }
                                    $scope.isRemoving[fileItem.documentId] = false;
                                }, function (data) {
                                    if (data) {
                                        $scope.isRemoving[fileItem.documentId] = false;
                                        fileItem.isDeletedDisabled = false;
                                        onErrorSave('unAuthorisedAccess', 'Delete Attachment');
                                    } else {
                                        $scope.isRemoving[fileItem.documentId] = false;
                                        fileItem.isDeletedDisabled = false;
                                        onErrorSave('errorDeleteDoc', 'Delete Attachment');
                                    }
                                });
                        }
                    });
            }
            else {
                fileItem.isDeletedDisabled = false;
                onErrorSave('errorDeleteDoc', 'Delete Attachment');
            }
            fileItem.isDeletedDisabled = false;
        }

        //This method gets the uploaded file from the database and shows it to the user
        $scope.viewDocument = function (fileItem) {
            var standalone = window.navigator.standalone;
            var userAgent = window.navigator.userAgent.toLowerCase();
            var safari = /safari/.test(userAgent);
            var ios = /iphone|ipod|ipad/.test(userAgent);

            $scope.isViewing[fileItem.documentId] = true;
            DataServices.viewDocument(fileItem.documentId)
                .then(function (response) {
                    var data = response && response.data;
                    try {
                        var file = new Blob([data], { type: fileItem.file.type }, { name: fileItem.file.name });
                        saveAs(file, fileItem.file.name);
                    }
                    catch (e) {
                        $scope.utility.openPopup('errorDownloadDoc');
                    }
                    $scope.isViewing[fileItem.documentId] = false;
                }, function () {
                    $scope.utility.openPopup('errorDownloadDoc');
                    $scope.isViewing[fileItem.documentId] = false;
                });
        }

        //This function enable the user to open a file dialog using enter key stroke
        $scope.upload = function (id) {
            $timeout(function () {
                angular.element('#' + id).trigger('click');
            }, 100);
        }

        //this method restricts the accepted file types to pdf and jpeg
        $scope.acceptedFileTypes = (function () {
            var allowedFileTypes = [
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'image/jpg',
                'image/jpeg',
                'image/png',
                'image/tiff',
                'image/tif',
                'application/pdf',
                'text/plain',
                'application/msword',
                'application/vnd.ms-excel',
                'application/octet-stream',
                'application/x-zip-compressed'
            ].join();
            var userAgent = window.navigator.userAgent.toLowerCase();
            var ios = /iphone|ipod|ipad/.test(userAgent);
            if (ios) {
                allowedFileTypes = ''; //iOS doesn't support this attribute. so don't restrict
            }
            return allowedFileTypes;
        })();

        //verify if a file extension is valid
        var isValidExtensions = function (fileType, fileName) {
            switch (fileType) {
                case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/png':
                case 'image/tiff':
                case 'image/tif':
                case 'application/pdf':
                case 'text/plain':
                case 'application/msword':
                case 'application/vnd.ms-excel':
                case 'application/zip':
                    return true;
                case 'application/octet-stream':
                case 'application/x-zip-compressed':
                    return fileName.substring(fileName.length - 4) === '.zip';
                default:
                    return false;
            }
            return false;
        }

        //validate the document for custom business requirement and then upload and save the file
        var validateAndUpload = function (fileItem) {
            var totalFileSize = 0;
            for (var i = 0; i < fileItem.uploader.queue.length; i++) {
                totalFileSize = parseInt(totalFileSize) + parseInt(fileItem.file.size);
            }
            if (totalFileSize > max_file_total_size) {
                fileItem.cancel();
                fileItem.remove();
                $scope.utility.openPopup('totalFileSize');
                return;
            }
            else {
                var uploadDateTimeString = new Date().toLocaleString('en-AU', { day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false });
                //a brand new attachment for the question needs to be uploaded
                var newDocumentToUpload = {
                    documentId: undefined,
                    uploadDateTime: uploadDateTimeString,
                    name: fileItem.file.name,
                    size: fileItem.file.size,
                    type: fileItem.file.type,
                    isFocus: fileItem.file.isFocus,
                    incidentId: DataServices.responseInfo.incidentId,
                    isDocUploaded: false
                };
                fileItem.uploadDateTime = uploadDateTimeString;
                $scope.responses.documents.push(newDocumentToUpload);

                if (DataServices.isAuthenticated()) {
                    fileItem.url = Constants.Url.getSaveDocumentURL;
                    fileItem.headers = { 'Authorization': 'Bearer ' + $window.sessionStorage.getItem('adal.access.token.key' + $window.__env.AzureADSettings.endpoints[$window.__env.apiUrl]) };
                } else {
                    fileItem.url = Constants.Url.getPublicSaveDocumentURL;
                }

                if (DataServices.responseInfo.incidentId !== null) {

                    fileItem.formData.push({ parentId: DataServices.responseInfo.incidentId });
                    fileItem.upload();
                } else {
                    //call the save on function to create a incident Id
                    $scope.isDH();
                    DataServices.saveIncidentForDocumentUpload($scope.IsDHVisible).then(
                        // sucess
                        function (result) {

                            fileItem.formData.push({ parentId: DataServices.responseInfo.incidentId });
                            fileItem.upload();
                        }
                    );
                }
            }
        }

        //custom method that executes when server returns a error 
        var onErrorSave = function (popupCode, sourceEvent) {
            $scope.utility.openPopup(popupCode);
            DataServices.trackEventsWithGA('Error occured during document action: ' + sourceEvent + 'on page:' + $scope.pageUrl, 'Document action', 'Document action failed.');
        };

        //method calls when page loads
        $scope.initPageAttachments();

    }]);
}());